var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('p',[_vm._v("You have two possible choices:")]),_c('p',[_vm._v("Create another combination of groups for the above scenario.")]),_c('p',[_vm._v("Complete your work with this scenario.")])])])
}]

export { render, staticRenderFns }